import { PointMaterial } from '@react-three/drei'
import { extend, useFrame } from '@react-three/fiber'
import React, { useMemo, useRef } from 'react'
import useStore from "../AppStore"


 const Stars = React.forwardRef((props,ref) => {
  const {count} = props
  const positions = useMemo(() => {
    let positions = []
    for (let i = 0; i < count; i++) {
      const r = 4000
      const theta = 2 * Math.PI * Math.random()
      const phi = Math.acos(2 * Math.random() - 1)
      const x = r * Math.cos(theta) * Math.sin(phi) + (-r/2 + Math.random() * r)
      const y = r * Math.sin(theta) * Math.sin(phi) + (-r/2 + Math.random() * r)
      const z = r * Math.cos(phi) + (-r/4 + Math.random() * r/2)
      positions.push(x*0.4)
      positions.push(y)
      positions.push(z)
    }
    return new Float32Array(positions)
  }, [count])
  
  const starsRef = useRef(null)
  
  useFrame(({clock}) => {
    const top = useStore.getState().top
    starsRef.current.rotation.x = Math.PI + top * 0.0003 + clock.elapsedTime*0.01
    starsRef.current.rotation.y = clock.elapsedTime*0.01
  })

  // useFrame((state, delta) => {
  //   // const far = 200+100*Math.sin(state.clock.getElapsedTime())
  //   // // geom.current.material.uniforms.far.value = far
  //   // geom.current.material.uniforms.time.value = state.clock.getElapsedTime()
  //   geom.verticesNeedUpdate = true
  // })
  return (
    <points {...props}  ref={starsRef}>
      <bufferGeometry>
        <bufferAttribute attachObject={['attributes', 'position']} count={positions.length / 3} array={positions} itemSize={3} />
      </bufferGeometry>
      {/* <PointMaterial scale={2} color={'#fff'} /> */}
      <pointsMaterial size={10} sizeAttenuation color={'white'} fog={false} />
    </points>
  )
})


export default Stars